// @flow

import { getEntries, joinArrayOrGetValue } from '../../../helpers';
import type { ACFResponsive, ACFResponsiveItem, Dimensions } from '../../../types';

const getColumnWidth = (value: ACFResponsiveItem): number => {
  if ('width' in value) {
    // @TODO shouldn't this be getValueOrArrayHead?
    return parseInt(joinArrayOrGetValue(value.width), 10);
  }
  return 12;
};

export default (responsive: ACFResponsive): Dimensions => {
  const defaultDimensions = {
    default: 12,
  };

  return getEntries(responsive).reduce((acc, [key, value]) => ({
    ...acc,
    [key.valueOf()]: getColumnWidth(value) / 12,
  }), defaultDimensions);
};
